import { htmlToText } from 'html-to-text';
import styled from 'styled-components';
/**
 * Renders the given `html` string and applies basic styling to the rendered elements (i.e. paragraphs, lists, etc.).
 * TODO: Sanitize input
 *
 * @example
 * <Text variant="copy1">
 *   <RenderHtml html={data.message} />
 * </Text>
 */
export function RenderHtml({
	id,
	html,
	className,
	...props
}: {
	id?: string;
	html: string | null | undefined;
	className?: string;
} & React.HTMLAttributes<HTMLSpanElement>) {
	if (!html) {
		return null;
	}

	return (
		<StyledProse className={className}>
			<span id={id} dangerouslySetInnerHTML={{ __html: html }} {...props} />
		</StyledProse>
	);
}

export function RenderShortendedText({ html }: { html: string | null | undefined }) {
	if (!html) return <></>;

	const result = getShortenedText(
		htmlToText(html, {
			preserveNewlines: true,
			formatters: {
				anchor: (el, walk, builder) => {
					builder.openBlock();
					walk(el.children, builder);
					builder.closeBlock();
				},
			},
		}),
	);

	return (
		<StyledProse>
			<span>{result}</span>
		</StyledProse>
	);
}

function getShortenedText(text: string) {
	if (text.length <= 144) return text;
	return text.substring(0, 144) + '…';
}

const StyledProse = styled.span`
	p:not(:last-child) {
		margin-bottom: 1rem;
	}

	ul {
		margin: 1rem 0;
		list-style: disc;
		list-style-position: inside;
		text-indent: calc(-1rem - 5px);
		margin-left: calc(1rem + 5px);
	}

	a {
		font-weight: 700;
		text-decoration: underline;
	}
`;
